export const humanizeAuthenticatedUser = (value: string | null) => {
  if (value === 'TCR_SUPPORT') {
    return 'TCR Support';
  }
  if (value === 'TCR_SYSTEM') {
    return 'TCR System';
  }
  return value || 'N/A';
};

export const constantizeAuthenticatedUser = (value?: string) => {
  if (value === 'TCR Support') {
    return 'TCR_SUPPORT';
  }
  if (value === 'TCR System') {
    return 'TCR_SYSTEM';
  }
  return value;
};
